import { translate } from 'App/Internationalization';
import images from 'config/local/images';
import LinkButton from 'shared/LinkButton';
import paths from 'config/local/paths';
import React from 'react';

export default function GatedBlogsOverlay() {
	return (
		<section className="w-3/4 mx-auto my-5 message message-themed-light">
			<header className="header">
				<h2 className="title large">
					{translate('agent.pages.widgets.blog.gated.cta')}
				</h2>
			</header>
			<main className="container-sm">
				<ul className="list-group">
					{[
						'boost_engagement',
						'demonstrate_expertise',
						'enhance',
					].map((value) => (
						<li
							// eslint-disable-next-line react/no-danger -- Markdown
							dangerouslySetInnerHTML={{
								__html: translate(
									`agent.pages.widgets.blog.gated.${value}`
								),
							}}
							key={value}
						/>
					))}
				</ul>
			</main>

			<footer className="footer">
				<LinkButton
					className="button button-icon"
					icon={images.icons.subscription}
					iconClass="icon"
					to={paths.app.agent.subscription.root}
				>
					{translate(
						'agent.pages.contacts.view.upgrade_table.upgrade'
					)}
				</LinkButton>
			</footer>
		</section>
	);
}
